import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-report-quote',
  templateUrl: './report-quote.component.html',
  styleUrls: ['../report.component.scss']
})
export class ReportQuoteComponent {
  @Input() data: any;
}
